module.exports = __webpack_public_path__ + "img/tre_trgametokens.4b1003c.png";